function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React, { useCallback, useRef } from 'react';
import { useRefCallback } from '@bydesign-ui/hooks';
import { classnames } from '@bydesign-ui/utils';
import { usePrefixCls, useDirection } from '@byte-design/config';
import { CheckSmall, Minus } from '../../common/icons';
import { CheckWrapper } from '../../units/check-wrapper';
export function Checkbox(props) {
  var className = props.className,
      _props$disabled = props.disabled,
      disabled = _props$disabled === void 0 ? false : _props$disabled,
      _props$checked = props.checked,
      checked = _props$checked === void 0 ? false : _props$checked,
      _props$indeterminate = props.indeterminate,
      indeterminate = _props$indeterminate === void 0 ? false : _props$indeterminate,
      children = props.children,
      onChange = props.onChange,
      onValueChange = props.onValueChange,
      restProps = _objectWithoutProperties(props, ["className", "disabled", "checked", "indeterminate", "children", "onChange", "onValueChange"]);

  var rtl = useDirection() === 'rtl';
  var ref = useRef(null);
  var cls = classnames(usePrefixCls('checkbox', {
    disabled: disabled,
    indeterminate: indeterminate,
    checked: checked,
    rtl: rtl
  }), className);
  var iconCls = usePrefixCls('checkbox-icon', {
    checked: checked
  });
  var labelCls = usePrefixCls('checkbox-label', {
    no: children === undefined || children === null || children === ''
  });
  return React.createElement(CheckWrapper, Object.assign({}, restProps, {
    type: "checkbox",
    className: cls,
    checked: checked,
    disabled: disabled,
    onChange: onChange,
    onValueChange: onValueChange,
    waveElementRef: ref
  }), React.createElement("span", {
    ref: ref,
    className: iconCls
  }, indeterminate ? React.createElement(Minus, {
    strokeWidth: 6
  }) : checked ? React.createElement(CheckSmall, {
    strokeWidth: 6
  }) : null), React.createElement("span", {
    className: labelCls
  }, children));
}

function ValuedCheckbox(props) {
  var falseValue = props.falseValue,
      _props$value = props.value,
      value = _props$value === void 0 ? falseValue : _props$value,
      onValueChange = props.onValueChange,
      trueValue = props.trueValue,
      extra = _objectWithoutProperties(props, ["falseValue", "value", "onValueChange", "trueValue"]);

  var onValueChangeCallback = useRefCallback(onValueChange);
  var onCheckboxValueChange = useCallback(function (newChecked) {
    onValueChangeCallback(newChecked ? trueValue : falseValue);
  }, []);
  return React.createElement(Checkbox, Object.assign({}, extra, {
    checked: value === trueValue,
    onValueChange: onCheckboxValueChange
  }));
}

Checkbox.Valued = ValuedCheckbox;